import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '*',
      redirect: '/'
    }, {
      path: '/',
      name: 'PageView',
      component: resolve => require(['@/view/PageView'], resolve),
      children: [
        {
          path: '/',
          redirect: '/home'
        }, {
          path: '/home',
          name: 'home',
          component: resolve => require(['@/view/HomePage'], resolve),
          meta: {
            title: 'KINLY健麗 | 專科眼袋權威'
          }
        }, {
          path: '/software',
          name: 'software',
          component: resolve => require(['@/view/Software'], resolve),
          meta: {
            title: '软件产品'
          },
          children: [
            {
              path: '/software',
              redirect: '/software/smartTown'
            },
            {
              path: '/software/smartTown',
              name: 'software',
              component: resolve => require(['@/view/Software_smartTown'], resolve),
              meta: {
                title: '软件产品丨智能小镇管理系统'
              }
            },
            {
              path: '/software/bigData',
              name: 'software',
              component: resolve => require(['@/view/Software_bigData'], resolve),
              meta: {
                title: '软件产品丨大数据管理系统'
              }
            }
          ]
        }, {
          path: '/service',
          name: 'service',
          component: resolve => require(['@/view/Service'], resolve),
          meta: {
            title: '星级疗程'
          }
        }, {
          path: '/newsinformation',
          name: 'newsinformation',
          component: resolve => require(['@/view/NewsInformation'], resolve),
          meta: {
            title: '用家实证'
          }
        }, {
          path: '/companyintroduction',
          name: 'companyintroduction',
          component: resolve => require(['@/view/CompanyIntroduction'], resolve),
          meta: {
            title: '最新优惠'
          }
        }, {
          path: '/jobchance',
          name: 'jobchance',
          component: resolve => require(['@/view/JobChance'], resolve),
          meta: {
            title: '工作机会'
          }
        }, {
          path: '/contactus',
          name: 'contactus',
          component: resolve => require(['@/view/ContactUs'], resolve),
          meta: {
            title: '联系我们'
          }
        },
        {
          path: '/servicedetail',
          name: 'servicedetail',
          component: resolve => require(['@/view/ServiceDetail'],resolve),
          meta: {
            title: '相关服务'
          }
        },
        {
          path: '/aboutus',
          name: 'aboutus',
          component: resolve => require(['@/view/AboutUs'],resolve),
          meta: {
            title: '关于我们'
          }
        },
        {
          path: '/help',
          name: 'help',
          component: resolve => require(['@/view/Help'],resolve),
          meta: {
            title: '知多的'
          }
        },
        {
          path: '/article',
          name: 'article',
          component: resolve => require(['@/view/Article'],resolve),
          meta: {
            title: '知多的'
          }
        },
        {
          path: '/experience',
          name: 'experience',
          component: resolve => require(['@/view/UserExperience'],resolve),
          meta: {
            title: '用家实证'
          }
        },
        {
          path: '/development',
          name: 'development',
          component: resolve => require(['@/view/Development'],resolve),
          meta: {
            title: '发展历程'
          }
        },
        {
          path: '/poster',
          name: 'poster',
          component: resolve => require(['@/view/PosterNew'],resolve),
          meta: {
            title: 'KINLY健麗|專科眼袋權威'
          }
        },
        {
          path: '/poster2',
          name: 'poster2',
          component: resolve => require(['@/view/PosterNew2'],resolve),
          meta: {
            title: 'KINLY健麗|專科眼袋權威'
          }
        },
        {
          path: '/posterNew',
          name: 'posterNew',
          component: resolve => require(['@/view/Poster'],resolve),
          meta: {
            title: 'KINLY健麗|專科眼袋權威'
          }
        },
        {
          path: '/bookingsuccess',
          name: 'bookingsuccess',
          component: resolve => require(['@/view/BookingSuccess'],resolve),
          meta: {
            title: 'KINLY健麗|專科眼袋權威'
          }
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js